
import api from './api'

export default {

    get(postId) {

        return api.get('/articles/' + postId, {})
            .then( json => {

                let article = json.data

                return article
            })
            
    }
}